import { Component, Input } from "@angular/core"
import NavigationNode from "../../models/navigationNode.model"
import { Colors } from "../../models/colors.model"
import { Router } from "@angular/router"
import { ColorCodeService } from "../../services/color-code.service"
import { GTMComponent } from "../../utils/gtmComponent"

@Component({
    selector: "app-side-navigation",
    templateUrl: "./side-navigation.component.html",
    styleUrls: ["./side-navigation.component.less"],
})
export class SideNavigationComponent extends GTMComponent {
    @Input() navigationNode: NavigationNode
    @Input() activeNode: NavigationNode
    @Input() color: string = "#2c40cb"
    @Input() styles: Colors

    constructor(private router: Router, private colorCodeService: ColorCodeService) {
        super()
    }

    public getColor() {
        if (this.isActive()) {
            if (this.styles.isEnabled) {
                return {
                    background: this.styles.colorBkgd,
                    color: this.styles.colorText,
                }
            }
            return {
                background: this.colorCodeService.collectionColors.defaultBackgroundColor,
                color: this.colorCodeService.collectionColors.defaultTextColor,
            }
        }
        return { background: "transparent" }
    }

    public isActive() {
        return this.activeNode && this.navigationNode.id === this.activeNode.id
    }

    selectNode(node) {
        this.router.navigate([node.getRouterLink()])
    }
}
